import React, { useEffect, useState } from "react";
import "./styles/index.scss";
import { useLandingPageData } from "./hooks/useLandingPageData";
import SectionRenderer from "./utils/SectionRenderer";
// import Loader from "./components/Loader";

import Header from "./components/Header";
import Footer from "./components/Footer";
import LanguageModal from "./components/LanguageModal";
import ErrorScreen from "./components/ErrorScreen";

function App() {
  const { data, loading, error, locale, changeLocale } = useLandingPageData();

  const [showLangModal, setShowLangModal] = useState(() => {
    return !localStorage.getItem("domm_lang_chosen");
  });

  const handleLanguageSelect = (lang) => {
    localStorage.setItem("domm_lang_chosen", "1");
    changeLocale(lang);
    setShowLangModal(false);
  };

  useEffect(() => {
    if (data) console.log("Landing data:", data, "locale:", locale);
  }, [data, locale]);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  if (loading)
    return (
      <>
        {/* <Loader loading={loading} /> */}
        {showLangModal && <LanguageModal onSelect={handleLanguageSelect} />}
      </>
    );
  if (error) return <ErrorScreen message={error.message} />;
  if (!data) return <ErrorScreen />;

  return (
    <>
      {showLangModal && <LanguageModal onSelect={handleLanguageSelect} />}
      <div className="content-wrapper">
        <Header
          data={data?.Header}
          current={locale}
          onLanguageChange={changeLocale}
        />
        <main>
          <SectionRenderer sections={data?.sections} />
        </main>
        <Footer
          data={data?.Header}
          current={locale}
          onLanguageChange={changeLocale}
        />
      </div>
    </>
  );
}

export default App;
